/**查看订单**/
<template>
  <div class="checkOrder">
    <xk-waiter :src="'../../../../assets/img/yonghu/touxiang.jpg'"
               :name="DjOrderInfo?DjOrderInfo.driverName:''"
               :headImg="DjOrderInfo?DjOrderInfo.driverPhoto:''"
    >
    </xk-waiter>
    <div class="money">
      <h2>
        <span class="max">{{DjPayInfo ? DjPayInfo.payMoney.toFixed(1).split('.')[0] : '0'}}</span>
        <span>.{{DjPayInfo && DjPayInfo.payMoney ? DjPayInfo.payMoney.toFixed(1).split('.')[1] : '0'}}元</span>
      </h2>
      <div class="detail">
        <span @click="detailsBoxFn"><i class="iconfont icon-iconfontyiwen"></i>查看明细</span>
      </div>
      <xk-star :defScore="DjQueryReview?DjQueryReview.score:5" :state="true"></xk-star>
      <div class="label">
        <xk-tag-item :name="item" :AcState="false" v-for="(item, index) in DjQueryReview?DjQueryReview.tabs:null"
                     :key="index"></xk-tag-item>
      </div>
      <div class="reviewContent">
        {{DjQueryReview && DjQueryReview.reviewContent && DjQueryReview.reviewContent !== '' ? DjQueryReview.reviewContent : '暂无评价'}}
      </div>
    </div>
    <Xk-detailsBox :title="'费用详情'" class="costBox" ref="detailsBox">
      <div slot="content">
        <ul>
          <li v-for="itme in payDataFn" v-if="itme.val !== 0" class="clear">
            <span class="name">{{itme.name}}</span>
            <span class="val"><span class="sum">{{itme.val}}</span><span class="unit">元</span></span>
            <span class="time" v-if="itme.time">{{itme.time}}<span class="unit">分钟</span></span>
          </li>
        </ul>
      </div>
    </Xk-detailsBox>
  </div>
</template>

<script>
  import XkWaiter from '../../module/waiter/src/waiter'
  import { mapGetters } from 'vuex'
  import Toucth from '../../../assets/js/method'
  import XkStar from '../../module/star/src/star'
  import XkTagItem from '../../module/tagitem/src/tagitem'

  export default {
    components: {
      XkTagItem,
      XkStar,
      XkWaiter
    },
    name: '',
    computed: {
      ...mapGetters({
        DjQueryReview: 'DjQueryReview',
        DjPayInfo: 'DjPayInfo',
        DjOrderInfo: 'DjOrderInfo',
        loginData: 'loginData'
      }),
      payDataFn: function () {
        let that = this
        let obj = []
        if (that.DjPayInfo) {
          if (that.DjPayInfo.payMoney) {
            obj.push({
              name: '服务费',
              val: (that.DjPayInfo.realCash - that.DjPayInfo.otherMoney - that.DjPayInfo.yuanchengMoney).toFixed(1)
            })
          }
          if (that.DjPayInfo.goodsCash) {
            obj.push({
              name: '商品价格',
              val: that.DjPayInfo.goodsCash.toFixed(1)
            })
          }
          if (that.DjPayInfo.guoluMoney) {
            obj.push({
              name: '过路费',
              val: that.DjPayInfo.guoluMoney.toFixed(1)
            })
          }
          if (that.DjPayInfo.otherMoney) {
            obj.push({
              name: '其他费用',
              val: that.DjPayInfo.otherMoney.toFixed(1)
            })
          }
          if (that.DjPayInfo.thanksCash) {
            obj.push({
              name: '感谢费',
              val: that.DjPayInfo.thanksCash.toFixed(1)
            })
          }
          if (that.DjPayInfo.yuanchengMoney) {
            obj.push({
              name: '远程费',
              val: that.DjPayInfo.yuanchengMoney.toFixed(1)
            })
          }
          if (that.DjPayInfo.couponMoney) {
            obj.push({
              name: '优惠券',
              red: true,
              val: (-that.DjPayInfo.couponMoney) + '.00'
            })
          }
        }
        return obj
      }
    },
    data () {
      return {
        data: {
          costDetail: [
            {
              name: '服务费',
              val: '00'
            },
            {
              name: '过路费',
              val: '00'
            },
            {
              name: '远程费',
              val: '00'
            },
            {
              name: '行驶时间费',
              val: '00',
              time: '0'
            },
            {
              name: '等待时长费',
              val: '00',
              time: '0'
            },
            {
              name: '其他（商品费，感谢费）',
              val: '00'
            },
            {
              name: '优惠券',
              val: '00'
            }
          ] // 费用详情
        }
      }
    },
    methods: {
      detailsBoxFn: function () { // 详情事件
        this.$refs.detailsBox.switchFn()
      }
    },
    watch: {
      DjPayInfo (val) {
        if (val) {
          this.data.costDetail = [
            {
              name: '服务费',
              val: this.DjPayInfo.payMoney
            },
            {
              name: '过路费',
              val: this.DjPayInfo.guoluMoney
            },
            {
              name: '远程费',
              val: this.DjPayInfo.yuanchengMoney
            },
            {
              name: '行驶时间费',
              val: this.DjPayInfo.runTimePrice,
              time: this.DjPayInfo.runTime
            },
            {
              name: '等待时长费',
              val: this.DjPayInfo.waitPrice,
              time: this.DjPayInfo.midwayWait
            },
            {
              name: '其他（商品费，感谢费）',
              val: this.DjPayInfo.otherMoney
            },
            {
              name: '优惠券',
              val: this.DjPayInfo.couponMoney
            }
          ]
        }
      },
      DjOrderInfo (val) {
        var that = this
        if (val) {
          if (that.loginData.passenger && val && that.loginData.passenger.id !== that.DjOrderInfo.clientId) {
            that.$router.push('/daijia')
            return
          }
        }
      }
    },
    mounted: function () {
      let that = this
      that.$store.dispatch('checkLogin', (state) => {
        if (state) {
          that.$store.dispatch('DjOrderInfo', {orderId: Toucth.AcquireUrlParameter().orderId})
          that.$store.dispatch('DjQueryReview', {
            passengerId: that.loginData.passenger.id,
            orderId: Toucth.AcquireUrlParameter().orderId
          })
          that.$store.dispatch('DjPayInfo', {orderId: Toucth.AcquireUrlParameter().orderId})
        }
      })
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .checkOrder {
    .money {
      padding-top: 3rem;
      text-align: center;
      h2 {
        font-size: 1.7rem;
        text-align: center;
        color: #f06553;
        .max {
          font-size: 3.2rem;
        }
      }
      .detail {
        line-height: 1.2rem;
        text-align: center;
        color: #878787;
      }
      .score {
        margin-top: 3rem;
        margin-bottom: 3rem;
      }
      .label {
        margin: 0 auto;
        margin-top: 1rem;
        width: 80%;
        text-align: center;
        .TagItem {
          box-sizing: border-box;
          width: calc(~'50% - 1rem');
          border-radius: 0;
          background: rgba(0, 0, 0, 0.04);
          font-size: 1rem;
          color: #999;
          border: none;
          line-height: 2.5rem;
          height: 2.5rem;
          margin: 0.3rem 0.5rem;
        }
      }
      .reviewContent {
        margin: 0 auto;
        box-sizing: border-box;
        width: 80%;
        margin-top: 1rem;
        line-height: 1.5rem;
        padding: 0.5rem;
        min-height: 5rem;
        border-radius: 0.333rem;
        text-align: center;
        color: #999;
      }
    }
    .costBox {
      ul {
        li {
          height: 2rem;
          line-height: 2rem;
          color: #999999;
          .name {
            float: left;
          }
          .time, .val {
            float: right;
          }
          .time {
            margin-right: 0.8rem;
            color: #333333;
          }
          .sum {
            color: #f06553;
          }
          .unit {
            margin-left: 0.3rem;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// checkOrder.vue?29f93bb1